'use strict';

const Signal = require('./Signal.js');
const ManchesterSignal = require('./ManchesterSignal.js');
const ProntoSignal = require('./ProntoSignal.js');
const Learner = require('./Learner.js');


module.exports = {
	Signal: Signal,
	ManchesterSignal: ManchesterSignal,
	ProntoSignal: ProntoSignal,
	Learner: Learner,
	makeSignal: function(opts) {
		let SignalCls = Signal;
		if(opts && opts.type && opts.type === 'prontohex') SignalCls = ProntoSignal;
		else if(opts && opts.type) throw new Error("unknown_type_"+opts.type);
		else if(opts && typeof opts.manchesterUnit !== 'undefined' ) SignalCls = ManchesterSignal;
		return new SignalCls(opts);
	}
};